import React, { useState } from 'react'

import { FAB } from '@/components'
import { BottomSheet } from '@/components/BottomSheet'
import { CreateJobForm, CreateTicketForm, HomeBlockForm, PropertyBlockForm } from '@/forms'
import { useToggle } from '@/hooks'
import { useTimeline } from '@/hooks/useTimeline'

type Props = {
  homeId: number
  propertyId: number
  refetchHome(): void
  refetchProperty(): void
  reservationId: number
}

export const QuickActionFob = ({ homeId, propertyId, reservationId, refetchHome, refetchProperty }: Props) => {
  const [selectedOption, setSelectedOption] = useState<SelectedOptionType>()
  const { isShown, toggle } = useToggle()
  const { isShown: modalShown, toggle: modalToggle } = useToggle()
  const { refetch: refetchTimeline } = useTimeline({ id: homeId })

  const showActionModal = (option: SelectedOptionType) => {
    toggle() // Close Fob Options

    setSelectedOption(option)
    modalToggle()
  }

  const onCreateJobSuccess = () => {
    modalToggle()
  }

  const onClose = () => {
    modalToggle()
  }

  type SelectedOptionType = (typeof statusOptions)[0]

  const statusOptions: { modalHeader?: string; name: string; value: OptionsValue }[] = [
    { name: 'Property Block Reason', value: OptionsValue.PROPERTY_BLOCK, modalHeader: 'Add Property Block Reason' },
    { name: 'Home Block Reason', value: OptionsValue.HOME_BLOCK, modalHeader: 'Add Home Block Reason' },
    { name: 'Create Host Job', value: OptionsValue.CREATE_HOST_JOB, modalHeader: 'Create Host Job' },
    { name: 'Create Ticket', value: OptionsValue.CREATE_TICKET, modalHeader: undefined },
  ]

  return (
    <>
      <FAB isShown={isShown} toggle={toggle}>
        {statusOptions.map((option, index) => {
          return (
            <button
              className={`option w-full whitespace-nowrap py-3 font-medium ${
                index !== 0 ? 'border-t border-secondary' : ''
              }`}
              key={index}
              onClick={() => showActionModal(option)}
            >
              {option.name}
            </button>
          )
        })}
      </FAB>
      <BottomSheet
        header={selectedOption?.modalHeader || undefined}
        isVisible={modalShown}
        mobileFullHeight={selectedOption?.value === OptionsValue.CREATE_TICKET}
        onClose={onClose}
      >
        <div className="px-6">
          {selectedOption?.value === OptionsValue.PROPERTY_BLOCK && (
            <PropertyBlockForm propertyId={propertyId} refetchOnSuccess={refetchProperty} toggle={modalToggle} />
          )}
          {selectedOption?.value === OptionsValue.HOME_BLOCK && (
            <HomeBlockForm homeId={homeId} refetchOnSuccess={refetchHome} toggle={modalToggle} />
          )}
          {selectedOption?.value === OptionsValue?.CREATE_HOST_JOB && (
            <CreateJobForm onSuccess={onCreateJobSuccess} reservationId={reservationId} />
          )}
        </div>
        {selectedOption?.value === OptionsValue.CREATE_TICKET && (
          <CreateTicketForm refetchOnSuccess={refetchTimeline} reservationId={reservationId} toggle={modalToggle} />
        )}
      </BottomSheet>
    </>
  )
}

enum OptionsValue {
  CREATE_HOST_JOB = 'create_host_job',
  CREATE_TICKET = 'create_ticket',
  HOME_BLOCK = 'home_block',
  PROPERTY_BLOCK = 'property_block',
}
